import { ReactElement } from 'react'

import { FormikHelpers } from 'formik'

import { ModifiedWidget } from 'types'

import SegmentTypeSelector from './SegmentTypeSelector'
import {
    migrateWidgetToParentLevel,
    updateWidgetToVariantLevel,
} from './segmentWidgetMigrator'

interface SegmentCustomWidgetSettingsProps {
    values: ModifiedWidget
    setValues: FormikHelpers<ModifiedWidget>['setValues']
    setFieldValue: FormikHelpers<ModifiedWidget>['setFieldValue']
}

function SegmentCustomWidgetSettings({
    values,
    setValues,
}: SegmentCustomWidgetSettingsProps): ReactElement {
    const handleSegmentTypeChange = (newValue: string): void => {
        const widgetValue = values
        if (widgetValue.type !== 'text') {
            if (newValue === 'variant_level') {
                const updatedWidget = updateWidgetToVariantLevel(widgetValue)
                setValues(updatedWidget as unknown as ModifiedWidget)
            } else {
                const migratedWidget = migrateWidgetToParentLevel(widgetValue)
                setValues(migratedWidget as unknown as ModifiedWidget)
            }
        }
    }

    return (
        <div style={{ marginTop: 20 }}>
            <SegmentTypeSelector
                value={
                    values.data_source_settings?.is_variant_level
                        ? 'variant_level'
                        : 'parent_level'
                }
                onChange={handleSegmentTypeChange}
            />
        </div>
    )
}

export default SegmentCustomWidgetSettings
